import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const CookieConsent: React.FC = () => {
    const [showCookieConsent, setShowCookieConsent] = useState(false);
    const { t } = useTranslation('common');

    useEffect(() => {
        const hasConsent = localStorage.getItem('cookieConsent');
        if (!hasConsent) {
            setShowCookieConsent(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setShowCookieConsent(false);
    };

    if (!showCookieConsent) return null;

    return (
        <div className="fixed bottom-4 right-4 max-w-md bg-white dark:bg-[#252526] rounded-lg shadow-lg p-6 z-50 border border-gray-200 dark:border-[#404040]">
            <div className="space-y-4">
                <p className="text-gray-600 dark:text-[#999999] text-sm">
                    {t('cookie_consent.text1')}
                </p>
                <p className="text-gray-600 dark:text-[#999999] text-sm">
                    {t('cookie_consent.text2')}
                </p>
                <div className="flex justify-end space-x-4">
                    <Button type="primary" id="cookie-consent-accept-button" onClick={handleAccept}>
                        {t('cookie_consent.accept')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
